import { Alert } from '@mui/material'
import { errorString } from '~/errors/handleApiError'
import type { ChartRegistryLookup } from './findChartRegistryRow'
import { MESSAGES } from './chrome/chartChrome'

interface Props {
  lookup: ChartRegistryLookup
}

// Renders the loud-failure visual for the non-ok branches of findChartRegistryRow.
// Returns null on 'loading' (parent renders its own loading state) and 'ok' (caller
// renders the actual chart). Centralises the F1 silent-fallback fix so all 4 sites
// (ChartTile timeline + absolute, ComparisonChartTile primary + comparison) share
// identical alert text.
export function ChartRegistryStatusFallback({ lookup }: Props) {
  if (lookup.status === 'loading' || lookup.status === 'ok') return null
  if (lookup.status === 'error') {
    return (
      <Alert severity="error">{errorString(lookup.error) ?? MESSAGES.chartConfigLoadFailed}</Alert>
    )
  }
  return <Alert severity="warning">{MESSAGES.chartNotConfigured(lookup.walkFn)}</Alert>
}
